import axios from 'axios'
import store from '../store'
import { itemscollection, activecollection, renewitems, renewcollection, chartdataxy, chartdatagroup } from "@/components/utility/indexdb";


var clctinitiate=function(clct){
  return new Promise(resolve=>{
    store.commit("reset")
    store.commit("setcollectionbyval",clct)
    authset(store.state.collection)
    fetchheader(store.state.collection)
    .then(
      (header)=>{
        toinitiate(store.state.collection);
        resolve(header);
      }

    )
    
  })


}

//设置collection的header
var fetchheader = function (obj) {
  return new Promise((resolve, reject) => {
    //this.target = obj.value;
    store.commit("setcurrentheader",[]);
    itemscollection.remove({})
    activecollection("headers")
      .findOne({ collection: obj.value })
      .then(doc => {
        //如果已经有header了那么调用
        if (doc) {
          store.commit("setcurrentheader", doc.header);
          resolve(doc.header);
          // return;
        }
        //没有就remote获取
        else {
          axios
            .post(url + "excelfields", { collection: obj.value })
            .then(res => {
              console.log("fetch header remotely");
              // console.log(res.data)
              store.commit("setcurrentheader", res.data);
              activecollection("headers")
                .remove({ collection: obj.value })
                .then(() => {
                  activecollection("headers").insert({
                    collection: obj.value,
                    header: res.data
                  });

                  resolve(res.data);
                });
            });
        }

      });
  });
}


 //设置collection的auth编辑权限
var authset=function(obj) {

  store.commit("setRoles", store.state.userroles)
  //如果editadminto存在且指定的editadmin中有该用户，那么该用户角色中增加editadmin,editadmin的权限相对有限，通过theform对数据进行变更
  if (obj.editadminto && (obj.editadminto.length === 0 || obj.editadminto.length > 0 && obj.editadminto.includes(store.state.user))) {
    let role = JSON.parse(JSON.stringify(store.state.userroles))
    role.push("editadmin")
    store.commit("setRoles", role)
  }


  //如果用户是dbadmin且不是superadmin
  //那么检查该collection是否指定了dbadminauthto
  //如果指定的dbadminauto中无本用户，那么设置的ROLES中移除dbadmin
  if (store.state.userroles.includes("dbadmin") && !store.state.userroles.includes("superadmin")) {
    if (obj.dbadminauthto.length > 0) {
      if (!obj.dbadminauthto.includes(store.state.user)) {
        //https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
        let role = store.state.roles.filter(item => item !== "dbadmin")
        store.commit("setRoles", role)
      }
    }
  }

}

//执行initiate初始化程序
var toinitiate=function(obj){
  let thestore =store 
  // 清空entranceinitial
  entranceHTML("<h5>Data Not Found</h1><h5>请重新搜索</h1>")
  try{
  eval(obj.initiate)
  }
  catch(err){
    console.log("clctinitiate error")
    console.log(err)
  }
  
}

var entranceHTML=function(html){
    let parentElement = document.getElementById("entrance_initial");
    parentElement.innerHTML = html;

}

let clctinitial={fetchheader,authset,clctinitiate,toinitiate}
export default clctinitial


// WEBPACK FOOTER //
// ./src/axios/clctinitial.js